import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="currency"
export default class extends Controller {

  static targets = ["origin", "exchange", "destination"]

  connect() {
  }

  select(event) {
    event.preventDefault();

    this.originTarget.value = event.target.dataset.originId;
    this.originTarget.dispatchEvent(new Event('change'));

    this.exchangeTarget.value = event.target.dataset.exchangeId;
    this.exchangeTarget.dispatchEvent(new Event('change'));

    this.destinationTarget.value = event.target.dataset.destinationId;
    this.destinationTarget.dispatchEvent(new Event('change'));

    console.log(event.target.dataset)

  }


}


